'use strict';

var i18n = require('i18next');
var EditWanDns = require('actions/wanDns/EditWanDns');
var FormView = require('actions/wanDns/FormView');
var StaticView = require('actions/wanDns/StaticView');

/**
 * Action configuration for the VLAN dns action component.
 */
module.exports = {
  title: i18n.t('actionWanDns.title'),
  Model: EditWanDns,
  FormView: FormView,
  TextView: StaticView,
};
